module.exports = __webpack_public_path__ + "static/media/59-iveco.fe852957.jpg";